import React, { useState, useContext } from 'react';
import { useTheme } from 'ThemeContext';
import Slick from 'react-slick';

import { AppSettingsContext } from 'AppSettingsContext';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  Box,
  Item,
  ItemExternal,
  Imagebox,
  Image,
  Content,
  Title,
  NextArrow,
  PrevArrow
} from './WidgetBanner.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

function WidgetBanner({ random = undefined, autoplaySpeed = 3000, data = [] }) {
  const [appSettings] = useContext(AppSettingsContext);
  const theme = useTheme();
  const [options] = useState({
    row: 0,
    dots: false,
    arrows: appSettings.theme === 4 ? true : false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: parseInt(autoplaySpeed)
  });

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <NextArrow onClick={onClick} theme={theme.widgetBanner.arrow}>
        <FontAwesomeIcon icon={faAngleRight} />
      </NextArrow>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <PrevArrow onClick={onClick} theme={theme.widgetBanner.arrow}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </PrevArrow>
    );
  }

  const renderItemInner = item => {
    return (
      <Imagebox>
        {item.image ? (
          <Image
            theme={theme.widgetBanner.image}
            src={item.image}
            loading='lazy'
            alt={item.title}
          />
        ) : (
          ''
        )}
        {item.title ? (
          <Content theme={theme.widgetBanner.textBox}>
            <Title theme={theme.widgetBanner.title}>{item.title}</Title>
          </Content>
        ) : (
          ''
        )}
      </Imagebox>
    );
  };

  return (
    <Box theme={theme.widgetBanner.box}>
      <Slick {...options}>
        {data &&
          data
            .filter(
              (item, key) =>
                (Number.isInteger(random) && key === random) ||
                !Number.isInteger(random)
            )
            .map((item, key) =>
              (item.slug && /(http(s?)):\/\//gi.test(item.slug)) ||
              (item.link && /(http(s?)):\/\//gi.test(item.link)) ||
              (item.url && /(http(s?)):\/\//gi.test(item.url)) ||
              item.url_outside ? (
                <ItemExternal
                  key={key}
                  title={item.title}
                  href={item.slug || item.link || item.url || item.url_outside}
                  target={
                    item._blank ||
                    item.link_blank ||
                    item.url_blank ||
                    item.url_outside_blank
                      ? '_blank'
                      : '' || item.target || ''
                  }
                  rel={
                    item.nofollow ||
                    item.link_nofollow ||
                    item.url_nofollow ||
                    item.url_outside_nofollow
                      ? 'nofollow'
                      : '' || item.rel || ''
                  }
                >
                  {renderItemInner(item)}
                </ItemExternal>
              ) : item.slug === '' || item.link === '' ? (
                <Item
                  key={key}
                  title={item.title}
                  smooth
                  to={(() => {
                    let slug;
                    if (data.slug)
                      slug =
                        data.slug[0] === '/' || data.slug[0] === '#'
                          ? data.slug
                          : `/${data.slug}`;
                    else if (data.link)
                      slug =
                        data.link[0] === '/' || data.link[0] === '#'
                          ? data.link
                          : `/${data.link}`;
                    else slug = '';

                    return slug;
                  })()}
                >
                  {renderItemInner(item)}
                </Item>
              ) : (
                ''
              )
            )}
      </Slick>
    </Box>
  );
}

export default WidgetBanner;
